const calculateInclusiveTax = (price: number, taxPercent: number): number => {
    return (price * taxPercent) / (100 + taxPercent);
};

const calculatePrice = (value: number, paymentMethod: string, taxDataCash: { tax_percent: string }, taxDataCard: { tax_percent: string }, isReverseCard: boolean): { final_price: number; exclusive_tax: number } => {
    let inclusiveTax = calculateInclusiveTax(value, parseInt(taxDataCash.tax_percent));
    if (paymentMethod && paymentMethod.toLowerCase() !== "cash" && !isReverseCard) {
        inclusiveTax = calculateInclusiveTax(value, parseInt(taxDataCard.tax_percent));
    }
    const exclusiveValue = Math.round((value - inclusiveTax) * 100) / 100;
    if (paymentMethod && paymentMethod.toLowerCase() !== "cash" && isReverseCard) {
        const exclusiveTax = exclusiveValue * parseInt(taxDataCard.tax_percent) / 100;
        const finalPrice = Math.round((exclusiveValue + exclusiveTax) * 100) / 100;
        // ItemTaxCharged = ItemTotalAmount - ItemSaleValue;
        return { final_price: finalPrice, exclusive_tax: finalPrice - exclusiveValue };
    }
    return { final_price: value, exclusive_tax: value - exclusiveValue };
};

const calcTotalGstTax = (cartData: any[], paymentMethod: string, isReverseCard: boolean, taxDataCash: { tax_percent: string }, taxDataCard: { tax_percent: string }, orderType: string, deliveryfee: number, page_type: string) => {
    let totalTax = 0;
    for (const item of cartData) {
        const itemLineTotal = item.price * item.quantity;
        const { exclusive_tax } = calculatePrice(itemLineTotal, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
        totalTax += exclusive_tax;

        if (item.modifiers) {
            for (const key of Object.keys(item.modifiers)) {
                for (const modItem of item.modifiers[key]) {
                    if (!modItem.selected) continue;
                    const basePrice =
                        modItem.discount_price || modItem.discount_price == 0
                            ? modItem.discount_price
                            : modItem.modifier_sale_price;
                    const modPrice = page_type == "orderSummary" ? modItem.originalPrice : basePrice;
                    const modLineTotal = modPrice * modItem.quantity;
                    const { exclusive_tax } = calculatePrice(modLineTotal, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
                    totalTax += exclusive_tax
                }
            }
        }
    }
    if (orderType.toLowerCase() === "delivery") {
        const deliveryFeeTax = calculateInclusiveTax(deliveryfee, paymentMethod && paymentMethod.toLowerCase() !== "cash" ? Number(taxDataCard.tax_percent) : Number(taxDataCash.tax_percent));
        totalTax += deliveryFeeTax;
    }
    return Math.round(totalTax * 100) / 100;
};
const calcFinalPriceFromUnit = (item: { price: number, quantity: number, modifiers: any }, paymentMethod: string, taxDataCash: { tax_percent: string }, taxDataCard: { tax_percent: string }, isReverseCard: boolean) => {
    const baseItemPrice = item.price;
    let { final_price } = calculatePrice(baseItemPrice, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
    final_price = final_price * item.quantity;
    if (item.modifiers) {
        for (const key of Object.keys(item.modifiers)) {
            for (const modItem of item.modifiers[key]) {
                if (!modItem.selected) continue;
                const basePrice =
                    modItem.discount_price || modItem.discount_price == 0
                        ? modItem.discount_price
                        : modItem.modifier_sale_price;
                const { final_price: mod_final_price } = calculatePrice(basePrice, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
                final_price += mod_final_price * modItem.quantity;
            }
        }
    }
    return final_price;
}

function getSlugFromName(name: string) {
  return name.replace(/\s+/g, "")
}
export { calculateInclusiveTax, calculatePrice, calcTotalGstTax, calcFinalPriceFromUnit, getSlugFromName };